export const CURRENCY_GET_REQUESTED = 'CURRENCY_GET_REQUESTED';
export const CURRENCY_GET_SUCCEED = 'CURRENCY_GET_SUCCEED';
export const CURRENCY_GET_FAILED = 'CURRENCY_GET_FAILED';

export const LANGUAGE_GET_REQUESTED = 'LANGUAGE_GET_REQUESTED';
export const LANGUAGE_GET_SUCCEED = 'LANGUAGE_GET_SUCCEED';
export const LANGUAGE_GET_FAILED = 'LANGUAGE_GET_FAILED';

export const COUNTRIES_GET_REQUESTED = 'COUNTRIES_GET_REQUESTED';
export const COUNTRIES_GET_SUCCEED = 'COUNTRIES_GET_SUCCEED';
export const COUNTRIES_GET_FAILED = 'COUNTRIES_GET_FAILED';

export const GET_PUBLIC_HOLIDAY_REQUESTED = 'GET_PUBLIC_HOLIDAY_REQUESTED';
export const GET_PUBLIC_HOLIDAY_SUCCEED = 'GET_PUBLIC_HOLIDAY_SUCCEED';
export const GET_PUBLIC_HOLIDAY_FAILED = 'GET_PUBLIC_HOLIDAY_FAILED';
